import React, { useState, useEffect } from "react";
import { db, doc, setDoc, onSnapshot } from "../config/firebase";
import "./AdminComponents.css";

const AdminStoreHours = () => {
  const [enabled, setEnabled] = useState(false);
  const [openTime, setOpenTime] = useState("09:00");
  const [closeTime, setCloseTime] = useState("20:30");
  const [forceClosed, setForceClosed] = useState(false);
  const [closureReason, setClosureReason] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      doc(db, "settings", "storeHours"),
      (snap) => {
        if (snap.exists()) {
          const data = snap.data();
          setEnabled(!!data.enabled);
          setOpenTime(data.openTime || "09:00");
          setCloseTime(data.closeTime || "20:30");
          setForceClosed(!!data.forceClosed);
          setClosureReason(data.closureReason || "");
        }
        setLoading(false);
      },
      (err) => {
        console.error("Error fetching store hours:", err);
        setLoading(false);
      }
    );
    return () => unsubscribe();
  }, []);

  const handleSave = async () => {
    try {
      setSaving(true);
      await setDoc(doc(db, "settings", "storeHours"), {
        enabled,
        openTime,
        closeTime,
        forceClosed,
        closureReason
      });
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (err) {
      console.error("Error saving store hours:", err);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="admin-store-hours">
      <h2 className="admin-section-title">Store Hours</h2>
      <p className="store-hours-description">
        Control when customers can place orders. When restriction is on, checkout will be
        blocked outside these hours and customers will see a "store closed" message.
      </p>

      <div className="store-hours-card">
        <label className="checkbox-label store-hours-toggle">
          <input
            type="checkbox"
            checked={enabled}
            onChange={(e) => setEnabled(e.target.checked)}
          />
          <span>Restrict orders to specific hours</span>
        </label>

        <div className="store-hours-times">
          <div className="form-group">
            <label>Opens at</label>
            <input
              type="time"
              value={openTime}
              onChange={(e) => setOpenTime(e.target.value)}
              disabled={!enabled}
            />
          </div>
          <div className="form-group">
            <label>Closes at</label>
            <input
              type="time"
              value={closeTime}
              onChange={(e) => setCloseTime(e.target.value)}
              disabled={!enabled}
            />
          </div>
        </div>

        <button className="btn-save" onClick={handleSave} disabled={saving}>
          {saving ? "Saving..." : saved ? "Saved ✓" : "Save Store Hours"}
        </button>
      </div>

      <div className="store-hours-card force-closed-card">
        <label className="checkbox-label store-hours-toggle">
          <input
            type="checkbox"
            checked={forceClosed}
            onChange={(e) => setForceClosed(e.target.checked)}
          />
          <span>Temporarily close the store (overrides hours above)</span>
        </label>
        <p className="store-hours-hint">
          Turn this on for holidays, emergencies, or an early closure — customers won't be
          able to check out until you turn it off again, no matter what the hours say.
        </p>

        <div className="form-group">
          <label>Reason to show customers (optional)</label>
          <input
            type="text"
            value={closureReason}
            onChange={(e) => setClosureReason(e.target.value)}
            placeholder="e.g. Closed for Diwali, back tomorrow"
            disabled={!forceClosed}
          />
        </div>

        <button className="btn-save" onClick={handleSave} disabled={saving}>
          {saving ? "Saving..." : saved ? "Saved ✓" : "Save"}
        </button>
      </div>
    </div>
  );
};

export default AdminStoreHours;